import { useState } from "react";
import { Tag } from "lucide-react";
import { useMealTags } from "../../contexts/MealTagContext";
import { LoadingComponent } from "../LoadingComponent";
import { EmptyState } from "../EmptyStateComponent";
import { ConfirmActionModal } from "../modals/ConfirmActionModal";
import { MealTagForm } from "./MealTagForm";
import { MealTagsList } from "./MealTagsList";

export function MealTagsSection() {
  const { mealTags, loading, addMealTag, removeMealTag } = useMealTags();
  const [tagToDelete, setTagToDelete] = useState(null);

  const handleConfirmDelete = () => {
    removeMealTag(tagToDelete);
    setTagToDelete(null);
  };

  if (loading) {
    return <LoadingComponent message="Loading your meal tags..." compact />;
  }

  return (
    <div className="max-w-2xl">
      <h2 className="text-lg font-semibold text-gray-900">Meal Tags</h2>
      <p className="text-sm text-gray-500 mt-1 mb-6">
        Create tags to categorize your recipes, like "Quick", "Vegan" or
        "Family Favorite".
      </p>

      <MealTagForm onAdd={addMealTag} existingTags={mealTags} />

      {mealTags.length === 0 ? (
        <EmptyState
          icon={Tag}
          title="No tags yet"
          description="Create your first meal tag to start organizing your recipes."
        />
      ) : (
        <MealTagsList mealTags={mealTags} onDelete={setTagToDelete} />
      )}

      {tagToDelete && (
        <ConfirmActionModal
          action={handleConfirmDelete}
          closeModal={() => setTagToDelete(null)}
          heading="Delete this tag?"
          message="This will remove the tag from any recipes using it. This action cannot be undone."
          confirmButtonText="Delete Tag"
        />
      )}
    </div>
  );
}
